import { Component, ElementRef, Inject, Input } from '@angular/core';
import { L10n } from '@skylab-angular-shared/core';
import { TrustResourcePipe } from '@skylab-angular-shared/pipes';
import { L10nBase } from '@skylab-shared/core';
import { $, $Element } from '../utils/element';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'skl-image',
    templateUrl: './image.component.html',
    imports: [TrustResourcePipe, IconComponent]
})
export class ImageComponent {
    @Input() public ratio!: string;
    @Input() public src!: string;
    @Input() public width = 100;
    @Input() public unit = '%';
    public height = 100;
    public imageFrameElement!: $Element;
    public emptyImageText!: string;

    public constructor(
        @Inject(L10n) private readonly l10n: L10nBase,
        private readonly elementRef: ElementRef) {}

    public ngOnInit(): void {
        this.imageFrameElement = $(this.elementRef.nativeElement).find('.js-image-frame');
        this.emptyImageText = this.l10n.instant('ui.image-picker.no-image');
        const { width, height } = this.setDimensions(this.width, this.height, this.ratio, this.unit);
        this.imageFrameElement.setCss({
            width,
            height,
        });
    }

    public gdc(a: number, b: number): number {
        return (b === 0) ? a : this.gdc(b, a % b);
    }

    public splitRatio(ratio: string): { width: number, height: number } {
        const [width, height] = ratio.split(':').map(item => parseInt(item, 10));
        return {
            width,
            height
        };
    }

    public getUnit(value: string): string {
        const matches = value.match(/(px|em|ex|%|in|cm|mm|pt|pc)$/g);
        const unit = matches ? matches[0] : '';
        return unit ? unit : 'px';
    }

    private setDimensions(widthRef: number, heightRef: number, ratioRef: string, unitRef: string): { width: string, height: string, ratio: string } {
        const unit = this.getUnit(unitRef);
        let width = `${ widthRef }${ unit }`;
        let height = `${ heightRef }${ unit }`;
        let ratio = ratioRef;
        if (ratio) {
            const { width: ratioWidth, height: ratioHeight } = this.splitRatio(ratioRef);
            if (!widthRef && heightRef) {
                width = `${ heightRef * ratioWidth / ratioHeight }${ unit }`;
            }
            if (!heightRef && widthRef) {
                height = `${ widthRef * ratioHeight / ratioWidth }${ unit }`;
            }
        } else if (widthRef && heightRef) {
            const gdc = this.gdc(widthRef, heightRef);
            ratio = `${ widthRef / gdc }:${  heightRef / gdc }`;
        }
        return {
            width,
            height,
            ratio,
        };
    }
}
